import { render, staticRenderFns } from "./ns-media.vue?vue&type=template&id=796ab6bc&"
import script from "./ns-media.vue?vue&type=script&lang=js&"
export * from "./ns-media.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports